"use strict";
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var _core = require("@uppy/core");
var _preact = require("preact");
var toArray = require("@uppy/utils/lib/toArray");
var isDragDropSupported = require("@uppy/utils/lib/isDragDropSupported");
var getDroppedFiles = require("@uppy/utils/lib/getDroppedFiles");
var packageJson = {
    "version": "2.1.2"
};
var locale = require("./locale.js");
/**
 * Drag & Drop plugin
 *
 */ var DragDrop = /*#__PURE__*/ function(_core_UIPlugin) {
    _inherits(DragDrop, _core_UIPlugin);
    function DragDrop(uppy, opts) {
        _class_call_check(this, DragDrop);
        var _this;
        var _this1;
        _this = _call_super(this, DragDrop, [
            uppy,
            opts
        ]), _this1 = _this;
        _this.handleDrop = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(event) {
                var _this$opts$onDrop, _this$opts, logDropError, files;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            event.preventDefault();
                            event.stopPropagation();
                            clearTimeout(_this1.removeDragOverClassTimeout); // Remove dragover class
                            _this1.setPluginState({
                                isDraggingOver: false
                            });
                            logDropError = function(error) {
                                _this1.uppy.log(error, 'error');
                            }; // Add all dropped files
                            return [
                                4,
                                getDroppedFiles(event.dataTransfer, {
                                    logDropError: logDropError
                                })
                            ];
                        case 1:
                            files = _state.sent();
                            if (files.length > 0) {
                                _this1.uppy.log('[DragDrop] Files dropped');
                                _this1.addFiles(files);
                            }
                            (_this$opts$onDrop = (_this$opts = _this1.opts).onDrop) == null ? void 0 : _this$opts$onDrop.call(_this$opts, event);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(event) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.type = 'acquirer';
        _this.id = _this.opts.id || 'DragDrop';
        _this.title = 'Drag & Drop';
        _this.defaultLocale = locale; // Default options
        var defaultOpts = {
            target: null,
            inputName: 'files[]',
            width: '100%',
            height: '100%',
            note: null
        }; // Merge default options with the ones set by user
        _this.opts = _object_spread({}, defaultOpts, opts);
        _this.i18nInit(); // Check for browser dragDrop support
        _this.isDragDropSupported = isDragDropSupported();
        _this.removeDragOverClassTimeout = null; // Bind `this` to class methods
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.handleDragOver = _this.handleDragOver.bind(_this);
        _this.handleDragLeave = _this.handleDragLeave.bind(_this);
        _this.handleDrop = _this.handleDrop.bind(_this);
        _this.addFiles = _this.addFiles.bind(_this);
        _this.render = _this.render.bind(_this);
        return _this;
    }
    _create_class(DragDrop, [
        {
            key: "addFiles",
            value: function addFiles(files) {
                var _this = this;
                var descriptors = files.map(function(file) {
                    return {
                        source: _this.id,
                        name: file.name,
                        type: file.type,
                        data: file,
                        meta: {
                            // path of the file relative to the ancestor directory the user selected.
                            // e.g. 'docs/Old Prague/airbnb.pdf'
                            relativePath: file.relativePath || null
                        }
                    };
                });
                try {
                    this.uppy.addFiles(descriptors);
                } catch (err) {
                    this.uppy.log(err);
                }
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(event) {
                var files = toArray(event.target.files);
                if (files.length > 0) {
                    this.uppy.log('[DragDrop] Files selected through input');
                    this.addFiles(files);
                } // We clear the input after a file is selected, because otherwise
                // change event is not fired in Chrome and Safari when a file
                // with the same name is selected.
                // ___Why not use value="" on <input/> instead?
                //    Because if we use that method of clearing the input,
                //    Chrome will not trigger change if we drop the same file twice (Issue #768).
                // eslint-disable-next-line no-param-reassign
                event.target.value = null;
            }
        },
        {
            key: "handleDragOver",
            value: function handleDragOver(event) {
                var _this$opts$onDragOver, _this$opts2;
                event.preventDefault();
                event.stopPropagation(); // Check if the "type" of the datatransfer object includes files. If not, deny drop.
                var types = event.dataTransfer.types;
                var hasFiles = types.some(function(type) {
                    return type === 'Files';
                });
                var allowNewUpload = this.uppy.getState().allowNewUpload;
                if (!hasFiles || !allowNewUpload) {
                    // eslint-disable-next-line no-param-reassign
                    event.dataTransfer.dropEffect = 'none';
                    clearTimeout(this.removeDragOverClassTimeout);
                    return;
                } // Add a small (+) icon on drop
                // (and prevent browsers from interpreting this as files being _moved_ into the browser
                // https://github.com/transloadit/uppy/issues/1978)
                //
                // eslint-disable-next-line no-param-reassign
                event.dataTransfer.dropEffect = 'copy';
                clearTimeout(this.removeDragOverClassTimeout);
                this.setPluginState({
                    isDraggingOver: true
                });
                (_this$opts$onDragOver = (_this$opts2 = this.opts).onDragOver) == null ? void 0 : _this$opts$onDragOver.call(_this$opts2, event);
            }
        },
        {
            key: "handleDragLeave",
            value: function handleDragLeave(event) {
                var _this = this;
                var _this$opts$onDragLeav, _this$opts3;
                event.preventDefault();
                event.stopPropagation();
                clearTimeout(this.removeDragOverClassTimeout); // Timeout against flickering, this solution is taken from drag-drop library.
                // Solution with 'pointer-events: none' didn't work across browsers.
                this.removeDragOverClassTimeout = setTimeout(function() {
                    _this.setPluginState({
                        isDraggingOver: false
                    });
                }, 50);
                (_this$opts$onDragLeav = (_this$opts3 = this.opts).onDragLeave) == null ? void 0 : _this$opts$onDragLeav.call(_this$opts3, event);
            }
        },
        {
            key: "renderHiddenFileInput",
            value: function renderHiddenFileInput() {
                var _this = this;
                var restrictions = this.uppy.opts.restrictions;
                return (0, _preact.h)("input", {
                    className: "uppy-DragDrop-input",
                    type: "file",
                    hidden: true,
                    ref: function(ref) {
                        _this.fileInputRef = ref;
                    },
                    name: this.opts.inputName,
                    multiple: restrictions.maxNumberOfFiles !== 1,
                    accept: restrictions.allowedFileTypes,
                    onChange: this.onInputChange
                });
            }
        },
        {
            key: "renderLabel",
            value: function renderLabel() {
                return (0, _preact.h)("div", {
                    className: "uppy-DragDrop-label"
                }, this.i18nArray('dropHereOr', {
                    browse: (0, _preact.h)("span", {
                        className: "uppy-DragDrop-browse"
                    }, this.i18n('browse'))
                }));
            }
        },
        {
            key: "renderNote",
            value: function renderNote() {
                return (0, _preact.h)("span", {
                    className: "uppy-DragDrop-note"
                }, this.opts.note);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var dragDropClass = "uppy-u-reset\n      uppy-DragDrop-container\n      ".concat(this.isDragDropSupported ? 'uppy-DragDrop--isDragDropSupported' : '', "\n      ").concat(this.getPluginState().isDraggingOver ? 'uppy-DragDrop--isDraggingOver' : '', "\n    ");
                var dragDropStyle = {
                    width: this.opts.width,
                    height: this.opts.height
                };
                return (0, _preact.h)("button", {
                    type: "button",
                    className: dragDropClass,
                    style: dragDropStyle,
                    onClick: function() {
                        return _this.fileInputRef.click();
                    },
                    onDragOver: this.handleDragOver,
                    onDragLeave: this.handleDragLeave,
                    onDrop: this.handleDrop
                }, this.renderHiddenFileInput(), (0, _preact.h)("div", {
                    className: "uppy-DragDrop-inner"
                }, DragDrop.renderArrowSvg(), this.renderLabel(), this.renderNote()));
            }
        },
        {
            key: "install",
            value: function install() {
                var target = this.opts.target;
                this.setPluginState({
                    isDraggingOver: false
                });
                if (target) {
                    this.mount(target, this);
                }
            }
        },
        {
            key: "uninstall",
            value: function uninstall() {
                this.unmount();
            }
        }
    ], [
        {
            key: "renderArrowSvg",
            value: function renderArrowSvg() {
                return (0, _preact.h)("svg", {
                    "aria-hidden": "true",
                    focusable: "false",
                    className: "uppy-c-icon uppy-DragDrop-arrow",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16"
                }, (0, _preact.h)("path", {
                    d: "M11 10V0H5v10H2l6 6 6-6h-3zm0 0",
                    fillRule: "evenodd"
                }));
            }
        }
    ]);
    return DragDrop;
}(_core.UIPlugin);
DragDrop.VERSION = packageJson.version;
module.exports = DragDrop;
